import(/* webpackMode: "eager" */ "/app/.next/cache/webpack/next-with-linaria/production/css/@linaria-css/src_layouts_default_styles_ts.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/app/node_modules/react-toastify/dist/react-toastify.esm.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationBar"] */ "/app/src/components/NavigationBar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AccountContextProvider"] */ "/app/src/context/account/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgeConfirmationProvider"] */ "/app/src/context/age-confirmation/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthContextProvider"] */ "/app/src/context/auth/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ChatReviewContextProvider"] */ "/app/src/context/chatReview/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaywallContextProvider"] */ "/app/src/context/paywall/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailConfirmDrawerBanner"] */ "/app/src/features/emailConfirm/ui/EmailConfirmDrawerBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailConfirmHeaderBanner"] */ "/app/src/features/emailConfirm/ui/EmailConfirmHeaderBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailConfirmModal"] */ "/app/src/features/emailConfirm/ui/EmailConfirmModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsBanner"] */ "/app/src/features/newsBanner/ui/NewsBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationEventListener"] */ "/app/src/hooks/useNotificationEventListener/index.tsx");
